(function () {
  // Guarda un handler de scroll/resize por seccion (clave = id del wrapper
  // #section-id-...) para poder quitarlo antes de reponer uno nuevo cuando
  // el theme editor recarga la seccion (evita apilar listeners).
  var parallaxHandlers = {};

  // Igual que parallaxHandlers, pero para los bucles requestAnimationFrame
  // de los stickers "Pin while scrolling": guarda una funcion de parada por
  // sticker para poder detenerlos antes de reinicializar la seccion.
  var stickerPinHandlers = {};

  // Igual que parallaxHandlers: guarda el handler de resize de
  // initTwoProductsPhotoHeight por seccion, para quitarlo antes de reponer
  // uno nuevo cuando el theme editor recarga la seccion.
  var twoProductsHeightHandlers = {};

  // Igual que parallaxHandlers: guarda el handler de resize de
  // initTwoProductsPhotoHeight por seccion, para quitarlo antes de reponer
  // uno nuevo cuando el theme editor recarga la seccion.
  var twoProductsHeightHandlers = {};

  function getSectionId(root) {
    var wrapper = root.closest('[id^="section-id-"]');
    return wrapper ? wrapper.id : null;
  }

  function initTabs(root) {
    if (root.dataset.categoryLandingTabsInit === 'true') return;
    root.dataset.categoryLandingTabsInit = 'true';

    var tabs = root.querySelectorAll('.category-landing__tag');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panelId = tab.getAttribute('data-panel');
        var panel = root.querySelector('#' + panelId);
        if (!panel) return;

        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('.category-landing__panel').forEach(function (p) {
          p.hidden = true;
        });

        tab.setAttribute('aria-selected', 'true');
        panel.hidden = false;

        // Los puntos debajo de las bolas indican en cual esta el usuario
        // (y, al haber varios, que se puede seguir haciendo scroll).
        root.querySelectorAll('.category-landing__tag-dot').forEach(function (dot) {
          var isActive = dot.getAttribute('data-dot-for') === tab.id;
          dot.classList.toggle('category-landing__tag-dot--active', isActive);
        });
      });
    });
  }

  function initDots(root) {
    if (root.dataset.categoryLandingDotsInit === 'true') return;
    root.dataset.categoryLandingDotsInit = 'true';

    root.querySelectorAll('.category-landing__tag-dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var tab = document.getElementById(dot.getAttribute('data-dot-for'));
        // Reutiliza el click del tab (mismo cambio de panel, misma
        // actualizacion de aria-selected y del resto de puntos) en vez de
        // duplicar esa logica aqui.
        if (tab) tab.click();
      });
    });
  }

  function initLazyExtra(root) {
    var sentinels = root.querySelectorAll('.category-landing__load-sentinel');

    sentinels.forEach(function (sentinel) {
      if (sentinel.dataset.lazyExtraInit === 'true') return;
      sentinel.dataset.lazyExtraInit = 'true';

      var target = document.getElementById(sentinel.dataset.loadSentinelFor);
      if (!target) return;

      if (!('IntersectionObserver' in window)) {
        // Sin soporte para IntersectionObserver: se muestran directamente,
        // mejor eso que dejarlos ocultos para siempre.
        target.hidden = false;
        return;
      }

      // rootMargin negativo en bottom: el aviso llega un poco antes de que
      // el marcador toque literalmente el borde inferior de la pantalla,
      // asi la carga se nota menos como un "salto" al hacer scroll.
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          target.hidden = false;
          observer.disconnect();
        });
      }, { rootMargin: '0px 0px 200px 0px' });

      observer.observe(sentinel);
    });
  }

  function initParallax(root) {
    var sectionId = getSectionId(root);

    if (sectionId && parallaxHandlers[sectionId]) {
      window.removeEventListener('scroll', parallaxHandlers[sectionId]);
      window.removeEventListener('resize', parallaxHandlers[sectionId]);
      delete parallaxHandlers[sectionId];
    }

    if (root.getAttribute('data-parallax-enabled') !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Imagenes de fondo decorativas: llevan su propia velocidad en
    // data-speed (markup propio de esta seccion). La imagen del banner de
    // categorias usa el snippet nativo 'image-desktop-and-mobile', que no
    // deja anadir data-speed al <img> real — su velocidad viaja en la
    // variable CSS --category-landing-parallax-speed puesta en el wrapper
    // que si controlamos (.category-landing__hero-image-wrapper).
    var bgImages = root.querySelectorAll('.category-landing__bg-image');
    var heroWrapper = root.querySelector('.category-landing__hero-image-wrapper');
    var heroImage = heroWrapper ? heroWrapper.querySelector('.theme-img') : null;

    if (!bgImages.length && !heroImage) return;

    var ticking = false;

    function update() {
      var sectionRect = root.getBoundingClientRect();

      bgImages.forEach(function (img) {
        var speed = parseFloat(img.getAttribute('data-speed')) || 0.4;
        var offset = sectionRect.top * speed * -1;
        img.style.transform = 'translateY(' + offset + 'px)';
      });

      if (heroImage) {
        var heroSpeed = parseFloat(getComputedStyle(heroWrapper).getPropertyValue('--category-landing-parallax-speed')) || 0.2;
        var heroWrapperRect = heroWrapper.getBoundingClientRect();
        var heroOffset = heroWrapperRect.top * heroSpeed * -1;
        heroImage.style.transform = 'translateY(' + heroOffset + 'px) scale(1.15)';
      }

      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (sectionId) parallaxHandlers[sectionId] = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initStickerPin(root) {
    var sectionId = getSectionId(root);

    if (sectionId && stickerPinHandlers[sectionId]) {
      stickerPinHandlers[sectionId].forEach(function (stop) {
        stop();
      });
      delete stickerPinHandlers[sectionId];
    }

    var stickers = root.querySelectorAll('.category-landing__sticker[data-pin-on-scroll="true"]');
    if (!stickers.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Referencia de "despegue": el banner de categorias de esta seccion si
    // existe (section.settings.banner_image es opcional), o la seccion
    // entera si no. Mismo patron que gilmore-hero.liquid (pin-on-scroll
    // nativo de KokoNote): --theme-header-height y .section-footer son las
    // variables/clases REALES de este tema (Prysm), no las de erickStore
    // (Dawn: --header-height / .footer).
    var hero = root.querySelector('.category-landing__hero') || root;
    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height'), 10) || 80;
    var isDesktop = window.matchMedia('(min-width: 768px)');
    var footer = document.querySelector('.section-footer');
    var stoppers = [];

    stickers.forEach(function (el) {
      var originalStyle = el.getAttribute('style');
      var pinFromStart = el.dataset.pinFromStart === 'true';
      var triggerOffset = parseFloat(el.dataset.pinTriggerOffset) || 0;
      var pinnedTop = parseFloat(el.dataset.pinnedTop) || 0;
      var pinnedLeft = parseFloat(el.dataset.pinnedLeft) || 0;
      var pinnedWidth = parseInt(el.dataset.pinnedWidth, 10) || el.offsetWidth;
      var pinnedRotation = parseFloat(el.dataset.pinnedRotation) || 0;
      var pinnedOpacity = el.dataset.pinnedOpacity || '1';
      var pinned = false;
      var stopped = false;

      function pin() {
        // Left mapeado sobre el mismo ancho de contenido "boxed" que usa
        // el header/anuncio (--container-pad-x), igual que el pin-on-scroll
        // nativo de gilmore-hero.liquid, en vez de un % simple de toda la
        // pantalla (que en monitores anchos no se alinearia con nada mas).
        var leftFraction = pinnedLeft / 100;
        el.style.position = 'fixed';
        el.style.top = pinnedTop + '%';
        el.style.left = 'calc(var(--container-pad-x, 0px) + ' + leftFraction + ' * (100% - (var(--container-pad-x, 0px) * 2)))';
        el.style.width = pinnedWidth + 'px';
        el.style.transform = 'rotate(' + pinnedRotation + 'deg)';
        el.style.opacity = pinnedOpacity;
        // Por debajo del header sticky del tema — mismo z-index que usa
        // el pin-on-scroll nativo (gilmore-hero.liquid).
        el.style.zIndex = '401';
        el.style.transition = 'opacity 250ms ease';
        pinned = true;
      }

      function unpin() {
        el.setAttribute('style', originalStyle);
        pinned = false;
      }

      function update() {
        if (!isDesktop.matches) {
          if (pinned) { unpin(); }
          return;
        }

        var heroRect = hero.getBoundingClientRect();
        var shouldPin = pinFromStart || heroRect.bottom <= headerHeight + triggerOffset;
        if (shouldPin && !pinned) { pin(); }
        else if (!shouldPin && pinned) { unpin(); }

        // Re-consultado en vivo (no cerrado sobre la variable "footer") por
        // si el footer llega a re-renderizarse despues de esta primera
        // consulta.
        var liveFooter = document.querySelector('.section-footer');
        if (pinned && liveFooter) {
          var footerRect = liveFooter.getBoundingClientRect();
          var shouldHide = footerRect.top < window.innerHeight;
          el.style.opacity = shouldHide ? '0' : pinnedOpacity;
          el.style.pointerEvents = shouldHide ? 'none' : '';
        }
      }

      function loop() {
        if (stopped) return;
        update();
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);

      stoppers.push(function () {
        stopped = true;
        if (pinned) { unpin(); }
      });
    });

    if (sectionId) stickerPinHandlers[sectionId] = stoppers;
  }

  // La foto/video de "2 productos + foto" se estira (align-self:stretch,
  // ver section-category-landing.css) para que su borde inferior quede a
  // la misma altura que el de las tarjetas de producto de al lado — pero
  // el cliente quiere que coincida solo con la IMAGEN del producto (donde
  // esta el boton "Anadir al carrito"), no con toda la tarjeta (el titulo/
  // precio quedan por debajo de la imagen). Como esa altura depende del
  // ancho real de la tarjeta (responsive) y no se puede calcular con un
  // aspect-ratio fijo sin quedar descuadrado, se mide con JS la altura
  // real de la imagen del primer producto y se aplica esa misma altura en
  // px a la foto, en escritorio (en movil la foto va en su propia linea,
  // sin nada con que alinear — ver el media query de section-category-landing.css).
  function initTwoProductsPhotoHeight(root) {
    var sectionId = getSectionId(root);
    if (sectionId && twoProductsHeightHandlers[sectionId]) {
      window.removeEventListener('resize', twoProductsHeightHandlers[sectionId]);
    }

    var groups = Array.prototype.slice.call(root.querySelectorAll('.category-landing__two-products'));
    if (!groups.length) return;

    var isDesktop = window.matchMedia('(min-width: 768px)');

    function sync() {
      groups.forEach(function (group) {
        var photo = group.querySelector('.category-landing__two-products-photo');
        if (!photo) return;
        if (!isDesktop.matches) {
          photo.style.height = '';
          return;
        }
        var imageBox = group.querySelector('.category-landing__two-products-product .image-cont');
        if (!imageBox) return;
        // Redondeo al pixel entero: el valor con decimales que da
        // getBoundingClientRect() puede quedar redondeado de forma distinta
        // por el navegador en la tarjeta (CSS aspect-ratio, automatico) que
        // en la foto (altura fija puesta aqui), dejando 1px de diferencia
        // visible entre ambos bordes inferiores.
        var h = Math.round(imageBox.getBoundingClientRect().height);
        if (h > 0) photo.style.height = h + 'px';
      });
    }

    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    if (sectionId) twoProductsHeightHandlers[sectionId] = sync;
  }

  function initSection(root) {
    initTabs(root);
    initDots(root);
    initLazyExtra(root);
    initParallax(root);
    initStickerPin(root);
    initTwoProductsPhotoHeight(root);
  }

  function initAll() {
    document.querySelectorAll('.category-landing').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Al recargar UNA seccion en el theme editor, re-inicializamos solo el
  // ".category-landing" de esa seccion (si lo tiene), no todas las de la
  // pagina.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.category-landing')
      : null;

    if (root) {
      initSection(root);
    } else {
      initAll();
    }
  });
})();
